module.exports = __webpack_public_path__ + "static/media/bus.b9b0db2e.ogg";